<template>
  <div class="group-input-code-ui">
    <div
      v-for="(item, index) in fields"
      :key="index"
      class="input-code-ui"
    >
      <label
        v-if="labels[index]"
        :for="`input-code-${index}`"
        class="visually-hidden"
      >
        {{ labels[index] }}
      </label>
      <input
        :id="`input-code-${index}`"
        :ref="`code${index}`"
        :aria-label="'label'"
        aria-required="true"
        autocomplete="off"
        :data-index="index"
        inputmode="numeric"
        type="tel"
        :name="`inputCode${index}`"
        maxlength="1"
        :pattern="pattern"

        :value="item"
        class="input-code-ui__input"
        :class="{'input-code-ui__input--focused': elFocus === index}"

        @input="onChange($event, index)"
        @keydown="onKeydown($event, index)"
        @focus="onFocus(index)"
        @blur="onBlur(index)"
      >
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { isIosMobile } from '../../../../utils/common';

const BACKSPACE_KEYCODE = 8;
const DELETE_KEYCODE = 46;

export default {
  name: 'GroupInputCodeUI',
  data() {
    return {
      code    : '',
      elFocus : null,
      labels  : ['Первое число кода', 'Второе число кода', 'Третье число кода', 'Четвертое число кода'],
      fields  : ['', '', '', ''],

      inputRegExp : /^[0-9]$/,
      pattern     : '^[0-9]$'
    };
  },

  watch: {
    // При изменении результирующего кода - обновляем поля
    code(val) {
      const result = [];

      this.fields.forEach((item, index) => {
        result.push(val[index] || '');
      });

      this.fields = result;

      this.$emit('update-code', val);
    }
  },

  methods: {
    replaceChar(str, index, char) {
      // заменяет символ в строке по индексу
      return str.substring(0, index) + char + str.substring(index + 1);
    },

    onFocus(index) {
      if (this.elFocus === index) {
        return;
      }

      // Запоминаем индекс элемента на котором стоит фокус
      this.elFocus = index;
    },

    onBlur(index) {
      setTimeout(() => {
        if (this.elFocus === index) {
          this.elFocus = null;
        }
      }, 100);
    },

    addCharCode(value, indexChar) {
      const isLastField = indexChar === this.fields.length - 1;
      const isNewChar = !this.code[indexChar];

      // Если у строки code уже есть значение для элемента с индексом indexChar - заменяем значение,
      // если ещё нет, то в строку последним элементом добавляем value
      if (this.code && this.code[indexChar]) {
        this.code = this.replaceChar(this.code, indexChar, value);
      } else if (this.code.length !== this.fields.length) {
        this.code += value;
      }

      // При добавлении символа перекидываем фокус на следующее поле:
      // - если это не последнее поле
      // - если это ввод нового символа
      // - если все предыдущие элементы заполнены и фокус на последнем заполненном элементе
      if (!isLastField && isNewChar && this.elFocus === this.code.length - 1) {
        const $input = this.$refs[`code${indexChar + 1}`];
        if ($input && $input.length) {
          $input[0].focus();
        }
      }
    },

    onChange($event, indexChar) {
      const $value = $event.target.value;

      // Если введена не цифра - возвращаем старое значение
      if ($value && !this.inputRegExp.test($value)) {
        this.fields = cloneDeep(this.fields);
        return;
      }

      // Если ввели или заменили цифру
      if ($value) {
        this.addCharCode($value, indexChar);
      } else {
        // Если удалили цифру
        this.code = this.replaceChar(this.code, indexChar, '');
      }
    },

    onKeydown($event, indexChar) {
      const keycode = $event.keyCode;

      // При нажатии на кнопки backspace или delete в пустой ячейке
      // - удаляем значение в предыдущей ячейке и перемещаем туда курсор
      if (indexChar !== 0 && !$event.target.value && (keycode === BACKSPACE_KEYCODE || keycode === DELETE_KEYCODE)) {
        this.code = this.replaceChar(this.code, (indexChar - 1), '');

        const $input = this.$refs[`code${indexChar - 1}`];
        if ($input && $input.length) {
          $input[0].focus();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../../css/redesign/utils/variables';

.group-input-code-ui {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  column-gap: 16px;
}

.input-code-ui {
  &__input {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 56px;
    height: 56px;
    line-height: 56px;
    padding: 16px;

    font-size: 16px;
    letter-spacing: -0.32px;
    border-radius: 12px;
    border: 1px solid $c-blue-common;

    text-align: center;
    color: $txt-black;
    background: $c-white;

    box-shadow: none;
    outline: none;

    @media (max-width: 767px) {
      width: 54px;
      height: 54px;
      line-height: 54px;

      font-size: 14px;
      letter-spacing: -0.28px;
    }
  }
}
</style>
